export enum FormCheckMsgs {
  NeedToDuplicatedCheck = '중복 확인을 해주세요.',
  AvailableStudentId = '사용 가능한 학번입니다.',
  AvailableProfessorId = '사용 가능한 교직원 번호입니다.',
  AvailableEmail = '사용 가능한 이메일입니다.',
  AvailablePhoneNum = '사용 가능한 연락처입니다.',
  InvalidInputValue = '잘못된 입력값입니다. 입력한 정보를 다시 확인해 주세요.',
  AlreadyExistStudentId = '이미 등록된 학번입니다. 다시 한번 확인해 주세요.',
  AlreadyExistProfessorId = '이미 등록된 교직원 번호입니다. 다시 한번 확인해 주세요.',
  AlreadyExistEmail = '이미 등록된 이메일입니다. 다시 한번 확인해 주세요.',
  AlreadyExistPhoneNum = '이미 등록된 연락처입니다. 다시 한번 확인해 주세요.',
  AlreadyExistPatientPhoneNum = '같은 번호를 가진 대상자가 존재합니다.',
}
